const GridOutline = ({ color = 'white' }: { color?: string }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.75 3C4.24011 3 3 4.24011 3 5.75V18.25C3 19.7599 4.24011 21 5.75 21H18.25C19.7599 21 21 19.7599 21 18.25V5.75C21 4.24011 19.7599 3 18.25 3H5.75ZM5.75 4.5H11.25V11.25H4.5V5.75C4.5 5.05089 5.05089 4.5 5.75 4.5ZM12.75 4.5H18.25C18.9491 4.5 19.5 5.05089 19.5 5.75V11.25H12.75V4.5ZM4.5 12.75H11.25V19.5H5.75C5.05089 19.5 4.5 18.9491 4.5 18.25V12.75ZM12.75 12.75H19.5V18.25C19.5 18.9491 18.9491 19.5 18.25 19.5H12.75V12.75Z" fill="#9CA3AF"/>
</svg>

)

export default GridOutline
